module.exports = __webpack_public_path__ + "components/flag/static/square/ee-9c0878a7af511c01e04687172ad13ed4.svg";